export default ($axios) => ({
    $axios,

    async self() {
        return await $axios.get('/self')
    },

    async updateImage(form) {
        return await $axios.post('/self/image', form)
    },

    async updateSelf(form) {
        return await $axios.put('/self', form)
    },

    async fetch() {
        return await $axios.get('/administrators')
    },

    async fetchById(id) {
        return await $axios.get(`/administrators/${id}`)
    },

    async create(form) {
        return await $axios.post('/administrators', form)
    },

    async update(id, form) {
        return await $axios.put(`/administrators/${id}`, form)
    },

    async remove(id) {
        return await $axios.delete(`/administrators/${id}`)
    },
})
